import { useMutation, MutationHookOptions } from "@apollo/client";
import mutationGQL from "@/Apollo/mutation/removeFavoriteProduct.graphql";

import {
  RemoveFavoriteProductMutation,
  RemoveFavoriteProductMutationVariables,
} from "@/Apollo/schema";
import { evictFavoritesList } from "@/common/utils/mutation.utils";

export const useRemoveFavoriteProduct = (
  options?: MutationHookOptions<
    RemoveFavoriteProductMutation,
    RemoveFavoriteProductMutationVariables
  >
) => {
  return useMutation<
    RemoveFavoriteProductMutation,
    RemoveFavoriteProductMutationVariables
  >(mutationGQL, {
    ...options,
    /* Composed, not overridden — callers pass their own `update` to patch the product itself. */
    update: (cache, result, context) => {
      evictFavoritesList(cache);
      options?.update?.(cache, result, context);
    },
  });
};
